import {
  fetchNavigationIcons,
  fetchNavigationPermissions,
  fetchProductNavigation,
  saveProductNavigation,
} from '@/services/navigationConfigService';
import { featureFlagService } from '@/feature-flags';
import type {
  NavigationNode,
  ProductNavigationTree,
} from '@/navigation/NavigationTypes';

export const navigationQueryKeys = {
  tree: (productId: string) => ['navigation-tree', productId] as const,
};

export async function getNavigationTree(
  productId: string,
): Promise<ProductNavigationTree> {
  return fetchProductNavigation(productId);
}

export async function saveNavigationTree(
  productId: string,
  nodes: NavigationNode[],
): Promise<ProductNavigationTree> {
  return saveProductNavigation(productId, nodes);
}

export async function getNavigationPermissions(): Promise<string[]> {
  return fetchNavigationPermissions();
}

export async function getNavigationIcons(): Promise<string[]> {
  return fetchNavigationIcons();
}

export async function getNavigationFeatureFlags(): Promise<string[]> {
  const result = await featureFlagService.query({
    page: 1,
    pageSize: 500,
    status: 'enabled',
  });

  return result.items.filter((flag) => flag.enabled).map((flag) => flag.key);
}
